import { Link as RouterLink } from 'react-router-dom';

import { CircularProgress as MaterialCircularProgress } from '@material-ui/core';
import { darken } from 'polished';
import styled, { css } from 'styled-components';

import colors from '../../styles/colors';

interface LinkProps {
  outline?: number;
}

export const Container = styled.div`
  font-family: 'Exo 2', sans-serif;
`;

export const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.07rem;

  button {
    background: none;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
    text-transform: uppercase;
    padding: 0.8rem 0;
    transition: ease-in background 0.2s;
    width: 12.8rem;
    margin-right: 1.4rem;
    border-radius: 5px;
    font-weight: 500;

    &:hover {
      color: ${colors.white};
      background: ${colors.primary};
      border: 0;
    }
  }
`;

export const Link = styled(RouterLink)<LinkProps>`
  background: ${colors.primary};
  color: ${colors.white};

  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1.7rem;

  width: 12.8rem;
  text-transform: uppercase;
  padding: 0.8rem 0;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2em;
  border-radius: 5px;
  transition: ease-in background 0.2s;

  &:hover {
    background: ${darken(0.1, `${colors.primary}`)};
    color: ${colors.white};
  }

  ${(props) =>
    props.outline &&
    css`
      background: transparent;
      color: ${colors.primary};
      border: 1px solid ${colors.primary};

      &:hover {
        background: transparent;
        border: 1px solid ${darken(0.1, `${colors.primary}`)};
        color: ${darken(0.1, `${colors.primary}`)};
      }
    `}
`;

export const ContainerInputSearch = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: ${colors.white};
  border-radius: 5px;
  padding: 0.7rem;
  font-size: 16px;
  border: 1px solid ${colors.gray};

  svg {
    margin-right: 0.3rem;
    fill: ${colors.gray};
  }

  input {
    width: 100%;
    background: none;
    border: 0;

    &::placeholder {
      color: ${colors.gray};
    }
  }
`;

export const Content = styled.div`
  background: ${colors.white};
  padding: 1.4rem 2.1rem;
`;

export const ContentFooter = styled.div`
  margin-top: 1.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CircularProgress = styled(MaterialCircularProgress)`
  position: absolute;
  top: 50%;
  left: 50%;
`;

export const RowData = styled.tr`
  svg {
    cursor: pointer;
    transition: ease-in all 0.2s;
    &:hover {
      color: ${colors.primary};
    }
  }

  td {
    &:first-child {
      width: 2.8rem;
      padding: 0 !important;
      text-align: left;

      &:before {
        content: '';
        border-radius: 5px;
        padding-top: 0.7rem !important;
        padding-bottom: 0.7rem !important;
      }
    }
    &:last-child {
      text-align: center;
    }
    height: 4.2rem;
    font-size: 14px;
    color: ${colors.lightblack};
    text-align: left;

    span {
      display: block;
      font-size: 14px;
    }
  }
`;

export const RowDetail = styled.tr`
  background: ${colors.lightgray};

  td {
    padding: 1.4rem;

    > div {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 2.1rem;
    }

    span {
      display: block;
      font-weight: bold;
      line-height: 1.5em;
      margin-bottom: 1.07rem;
    }
  }
`;

export const Pagination = styled.ul`
  margin-top: 2.1rem;
  height: 2.1rem;
  display: flex;
  align-items: center;

  button {
    background: none;
    margin-right: 1.4rem;
    border: none;
    transition: color 0.2s;

    svg {
      fill: ${colors.gray};
    }

    &:hover {
      svg {
        fill: ${colors.primary};
      }
    }
  }
  .active {
    color: ${colors.primary};
    font-weight: bold;
    border-bottom: 0.1rem solid ${colors.primary};

    &:hover {
      color: ${colors.primary};
    }
  }

  a {
    font-size: 16px;
    text-decoration: none;
    color: ${colors.gray};
    margin-right: 1.4rem;
    transition: color 0.2s;

    &:hover {
      color: ${colors.darkgray};
    }
  }
`;
